const $BackToTop = $('.BackToTop');

$(() => {
  $BackToTop.on('click', function (event) {
    const $root = jQuery('html, body');

    event.preventDefault();

    $root.animate(
      {
        scrollTop: 0,
      },
      1000
    );
  });

  const onScroll = function () {
    if ($('body').scrollTop() || $('html').scrollTop() > 200) {
      $BackToTop.addClass('visible').addClass('init');
    } else {
      $BackToTop.removeClass('visible');
    }
  };

  $(window).on('scroll', onScroll);
  $(document).on('touchmove', onScroll);
});
